import { takeEvery, fork, put, all, call } from "redux-saga/effects";

//Account Redux states
import * as TYPES from "./actionTypes";
import * as ACTIONS from "./actions";
import { loginSuccess } from "../login/actions";
import * as API from "helpers/backend_helper";
import { updateToken } from "helpers/api_helper";

import {errorMsg, successMsg} from "helpers/toastr";

 /**
      * Used for calling auth user api
      */


function* registerUser({ payload: { user, callback } }) {
  try {
    const response = yield call(API.postRegister, user);
    callback && callback(response);
    if (response.status == "failure") {
      window.scrollTo(0, 0);
      return yield put(ACTIONS.registerUserFailed(response.message));
    }
    yield put(ACTIONS.registerUserSuccessful(response));
    yield put(loginSuccess(response));
    updateToken(response.data.Token);

    localStorage.setItem("authUser", JSON.stringify(response));
  } catch (error) {
    yield put(ACTIONS.registerUserFailed(error?.response?.data?.message));
    errorMsg(error?.response?.data?.message);

  }
}

function* getKycDetail({ payload: { user, callback } }) {
  try {
    const response = yield call(API.postKycDetail, user);

    callback && callback(response);
    if (response.status == "failure") {
      errorMsg(response.message)
      return yield put(ACTIONS.getKycFail(response.message));
    }

    yield put(ACTIONS.getKycSuccessful(response));
  } catch (error) {
    yield put(ACTIONS.getKycFail("Internal Server Error"));
    errorMsg(error.response.data.message)

  }
}


function* getKycStatus({ payload: { user, callback } }) {
  try {
    const response = yield call(API.postKycStatus, user);

    callback && callback(response);
    if (response.status == "failure") {
      return yield put(ACTIONS.getKycStatusFail(response.message));
    }
    let authInfo = JSON.parse(localStorage.getItem("authUser"))

    authInfo.data.kycDetails = response?.data?.kycDetails;
    localStorage.setItem("authUser", JSON.stringify(authInfo));
    yield put(ACTIONS.registerUserSuccessful(authInfo));
    yield put(loginSuccess(authInfo));


    yield put(ACTIONS.getKycStatusSuccessful(response));

  } catch (error) {
    yield put(ACTIONS.getKycStatusFail("Internal Server Error"));
  }
}



function* getProfile({ payload: { data, callback } }) {
  try {
    const response = yield call(API.postUserProfile, data);

    callback && callback(response);
    if (response.status == "failure") {
      return yield put(ACTIONS.getProfileFail(response.message));
    }

    let authInfo = JSON.parse(localStorage.getItem("authUser"))
    authInfo.data.profileImage = response?.data?.profileImage;
    localStorage.setItem("authUser", JSON.stringify(authInfo));
    yield put(loginSuccess(authInfo));

    yield put(ACTIONS.getProfileSuccessful(response));
  } catch (error) {
    yield put(ACTIONS.getProfileFail("Internal Server Error"));
  }
}
export function* watchUserRegister() {
  yield takeEvery(TYPES.REGISTER_USER, registerUser);
  yield takeEvery(TYPES.GET_KYC, getKycDetail);
  yield takeEvery(TYPES.GET_KYC_STATUS, getKycStatus);
  yield takeEvery(TYPES.GET_PROFILE, getProfile);


}

function* accountSaga() {
  yield all([fork(watchUserRegister)]);
}

export default accountSaga;
